const fieldsDefinitions = {
  gender: {
    label: "Gender",
    default: "NA"
  },
  secondary: {
    label: "AML Type",
    default: "NA",
    values: {
      1: "Primary",
      2: "Secondary",
      3: "Other",
      NA: "N/A"
    }
  },
  ahd: {
    label: "Has Antecedent",
    verboseLabel: "Antecedent of Hematological Disorder (ex. MDS)",
    default: "NA",
    values: {
      1: "YES",
      0: "NO",
      NA: "UNKOWN"
    }
  },
  perf_status: {
    label: "Performance",
    verboseLabel: "Performance (ECOG)",
    default: "NA",
    values: {
      0: "0 - Fully Active",
      1: "&nbsp;1 - Restricted in physical activity", // Space to align fonts vertically
      2: "2 - Capable of selfcare but no work activities",
      3: "3 - Limited selfcare",
      4: "4 - Completely disabled",
      NA: "N/A"
    }
  },
  age: {
    min: 0,
    max: 120,
    units: "years",
    label: "Age at Diagnosis",
    validation: true,
    default: null
  },
  wbc: {
    min: 0.2,
    max: 600,
    units: "10<sup>9</sup>/l",
    label: "White Cell Count",
    validation: true,
    default: null
  },
  plt: {
    min: 2,
    max: 3500,
    units: "10<sup>9</sup>/l",
    label: "Platelet Count",
    validation: true,
    default: null
  },
  bm_blasts: {
    min: 0,
    max: 100,
    units: "%",
    label: "Bone Marrow Blasts",
    validation: true,
    default: null
  },
  hb: {
    min: 2.5,
    max: 18.0,
    units: "g/dl",
    label: "Hemoglobin",
    validation: true,
    default: null
  }
};

export default fieldsDefinitions;
